import { Pipe, PipeTransform } from "@angular/core";
import {
  IShoppingCartItemViewModel,
  IShoppingCartViewModel,
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
} from "src/domain/client";
import { EcomProductArray } from "src/domain/ecomProductArray";
import { nonNullish } from "src/guards";
import { IProduct } from "src/interfaces/gtm-interfaces";
import { BrandService } from "src/services/brand.service";

@Pipe({
  name: "ecomProduct",
})
export class EcomProductPipe implements PipeTransform {
  constructor(private brandService: BrandService) {}
  transform(cartItem: IShoppingCartItemViewModel): IProduct | null {
    const { product } = cartItem;
    if (product == null || product.sku == null) return null;
    const price = product.price?.listPrice;
    if (price == null) return null;
    const discount = product.price?.adjustmentAmount || undefined;
    const itemName = product.media?.find(
      ({ mediaTypeName, mediaCategoryTypeName }) =>
        mediaTypeName === MediaTypeNameEnum.Text &&
        mediaCategoryTypeName == MediaCategoryTypeNameEnum.ProductName,
    )?.content;

    const brand =
      this.brandService.specialBrand?.urlShort ??
      this.brandService.brand?.urlShort;

    const { host } = window.location;

    return {
      item_id: product.sku,
      item_name: itemName,
      item_brand: product.trademark,
      price,
      discount,
      quantity: cartItem.quantity ?? 1,
      affiliation: brand ? `${brand}@${host}` : host,
    };
  }
}

@Pipe({
  name: "ecomProductAray",
})
export class EcomProductArrayPipe implements PipeTransform {
  constructor(private ecomProductPipe: EcomProductPipe) {}
  transform(shoppingCart?: IShoppingCartViewModel | null): EcomProductArray {
    if (!shoppingCart?.shoppingCartItems) return new EcomProductArray();
    return new EcomProductArray(
      shoppingCart.shoppingCartItems
        .map((item) => this.ecomProductPipe.transform(item))
        .filter(nonNullish),
    );
  }
}
